import actionTypes from './constants';

/* */
export const setContactsList = (list) => (dispatch) => dispatch({
  type: actionTypes.SET_CONTACTS_LIST,
  payload: list,
});

/* */
export const addContact = (data) => (dispatch) => dispatch({
  type: actionTypes.ADD_CONTACT,
  payload: data,
});

/* */
export const updateContact = (data) => (dispatch) => dispatch({
  type: actionTypes.UPDATE_CONTACT,
  payload: data,
});

/* */
export const deleteContact = (data) => (dispatch) => dispatch({
  type: actionTypes.DELETE_CONTACT,
  payload: data,
});
